import codes from '@/codes';
import forge from 'node-forge'
import iconv from 'iconv-lite'
import { saveAs } from 'file-saver/FileSaver';

//restful api
import { webshell as wsfinder } from '@/service/api/wsfinder'

export default {
  data : () => {
    return {
      confirm: false,
      pattern_del: true,
      lock: true,
      model : {},
      codes
    }
  },
  methods: {
    download: function(){
      let blob = new Blob([this.model.data], {type: "text/plain;charset=utf-8"});
      saveAs(blob, this.model.name+'.F1');
    },
    remove: function() {
      return wsfinder.deleteWebshell({ id : this.model.id})
        .then((rs) => {
          if(!rs.error) {
            this.$toastr.s('removed.', this.$route.name);
          } else {
            console.log("remove", 'failed', rs.reason, this.model.id)
            this.$toastr.e('delete', "failed")
          }
          this.list(); this.$emit("refresh");
        })
        .catch(e => (this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list()));
    },
    list: function() { this.$router.push({ name: 'wsfinder_webshell'}); },

    get: function(id = this.$route.params.id) {
      console.log('webshell.detail.vue', 'load item', id);
      wsfinder.detailWebshell({id:id}).then(data => this.model = Object.assign({}, this.model, data.body))
      .then( model => {
        let decode = forge.util.decode64(model.data);
        if(!model.is_binary) { try { this.model.data = forge.util.decodeUtf8(decode);} catch(e) { this.model.data = iconv.decode(decode, 'Windows949');}}
      })
      .catch(e => (this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list()));
    }
  },
  watch: { '$route' (to, from) { console.log(`from : ${from}`); } },
  created: function() { console.log('webshell.detail.vue', 'created'); },
  destroyed: function() { console.log('webshell.detail.vue', 'destroyed'); },
  mounted: function() {
    console.log('webshell.detail.vue', 'mounted');
    this.get(this.$route.params.id);
  },
}